import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=23fab4a6&scoped=true&"
import script from "./Award.vue?vue&type=script&lang=js&"
export * from "./Award.vue?vue&type=script&lang=js&"
import style0 from "./Award.vue?vue&type=style&index=0&id=23fab4a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fab4a6",
  null
  
)

export default component.exports